import React from "react"



const Pagination = ({
    totalPage,
    setCurrentPage,
    currentPage,
}) => {
    let pages = []

    for (let i = 1; i <= totalPage; i++) {
        pages.push(i)
    }

    return (
        <div className="card-shadow lespage  mb-3 py-1 text">
            <nav aria-label="..." style={{ backgroundColor: "transparent", boxShadow: "none" }}>
                <ul className="pagination ">
                    {currentPage > 1 ?
                        <li className="page-item">
                            <a className="page-link" href="#" onClick={() => setCurrentPage(currentPage - 1)}>Précédent</a>
                        </li>
                        : <></>
                    }

                    <li className="page-item active">
                        <span className="page-link">
                            {currentPage}

                        </span>
                    </li>
                    {currentPage < totalPage ?
                        <li className="page-item">
                            <a className="page-link" href="#" onClick={() => setCurrentPage(currentPage + 1)} >Suivant</a>
                        </li>
                        : <></>
                    }
                </ul>
            </nav>
        </div>
    )
}

export default Pagination